import { EmployeeTerminationApprovalStatus } from "../..";
import {RolesList} from '@gtpl/shared-models/gtpl';
export class EmployeeDto {
    Id?: number;
    empName: string;
    empCode: string;
    costcenterId: number;
    projectId:number;
    mobileNo: string;
    Role: string;
    maritalStatus:string;
    employmentMode:string;
    emailId: string;           
    Gender:string;
    subContractorId:number;
    otApplicable:boolean;
    designationId:number;
    isTerminated: boolean;
    terminationApprovedBy: number;
    isTerminationApproved:boolean;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
    projectName? : string;
  }
  
  export const EmployeeDtoDefault : EmployeeDto = {
    Id: 1,
    empName: "",
    empCode: "",
    costcenterId: 0,
    projectId:0,
    mobileNo: "",
    Role: '',
    employmentMode:'GTPL',
    maritalStatus:'Married',
    emailId: "",
    Gender:"Male",
    subContractorId:0,
    otApplicable:true,
    isTerminated: false,
    isTerminationApproved:false,
    terminationApprovedBy: 0,
    designationId:0,
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 0
  };
  
  